import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useParams, Redirect } from 'react-router-dom';
import centredForm from '../components/centredForm';
import ErrorMsg from '../components/ErrorMsg';

function ShortCodeForm(props) {
  let { authenticating, isAuthenticated, login, error, history } = props;
  let { code, pin } = useParams();
  let { t } = useTranslation();
  useEffect(() => {
    if (code && pin) {
      login(code, pin, history);
    }
  }, [code, pin, history, login]);
  if (authenticating) {
    return (
      <Typography variant="h5" align="center">
        {t('pleaseWait')}
      </Typography>
    );
  }
  if (error) {
    return <ErrorMsg error={error} />;
  }
  if (isAuthenticated) {
    return <Redirect to={'/applications'} />;
  }
  return null;
}

export default centredForm(ShortCodeForm, '', 350);



// WEBPACK FOOTER //
// ./src/view/scenes/ShortCodeLogin/ShortCodeLogin.js